import { API_AUTH_BASE_URL, APP_ID } from '@/constants'
import httpClient from './http/http-client'
import type { Me } from '@/types'
import type { ResponseResult } from '@/types/http'

export interface SignInResult {
  data: {
    token: string
  }
}

export interface ExceptionResult {
  message: string
  errors: Record<string, string[]>
}

interface SendCodeParams {
  email: string
}

interface LoginParams {
  email: string
  code: string
}

const baseURL = API_AUTH_BASE_URL
const appId = APP_ID

export async function login(params: LoginParams) {
  return httpClient
    .post<SignInResult>('/login', params, { baseURL, headers: { 'X-App-Id': appId } })
    .then(({ data }) => data)
}

export async function logout() {
  return httpClient.post<void>('/logout', {}, { baseURL })
}

export async function sendCode(params: SendCodeParams) {
  return httpClient.post<void>('/send-code', params, { baseURL, headers: { 'X-App-Id': appId } })
}

export async function getMe() {
  return httpClient.get<ResponseResult<Me>>('/me', { baseURL }).then(({ data }) => data)
}
